import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  callingAPI: false,
  searching: '',
  serverURI: 'https://api.unitedtaxi.co/',
  // serverURI: 'http://localhost:8000/',
  user: null,
  token: null,
  userInfo: {
    messages: [{message: 'test',sender : '123456789',update_time: new Date(), status : 0 }],
    notifications: [],
    tasks: []
  }
}

const mutations = {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_TOKEN (state, token) {
    state.token = token
  }
}

const actions = {
  doToggleLoading({commit}, state){
    commit('TOGGLE_LOADING', state)
  },
  doToggleSearch({commit}, todo){
    commit('TOGGLE_SEARCHING', todo)
  },
  doSetUser({commit}, state, user){
    commit('SET_USER', state, user)
  },
  doSetToken({commit}, state, token){
    commit('SET_TOKEN', state, token)
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store.js